<template>
  <div
    class="flex items-center flex-col justify-center overflow-hidden fixed inset-0"
    :class="zIndex"
  >
    <div class="absolute inset-0 bg-theme-bg/40 backdrop-blur-sm" @click="overlayClick"></div>
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'Overlay',
    emits: ['overlay-click'],
    props: {
      zIndex: {
        type: String,
        default: 'z-drawer',
      },
    },
    setup(props, { emit }) {
      const overlayClick = (event) => {
        emit('overlay-click', event);
      };

      return {
        overlayClick,
      };
    },
  };
</script>
